import axios from "axios";
import { authorizeToCustomRest } from "../../../features/customAuth/customAuth";

export async function fetchCustomObjectInfo(entityId: string, objectInfoApi: any, authRequestOptions: any, authToken?: string) {
    let { url, fetchPlan, view, requestMethod } = objectInfoApi ?? {}
    url = url?.replace(':entityId', entityId)
    let queryParams
    if (requestMethod === 'GET') {
        if (fetchPlan) queryParams = { fetchPlan }
        if (view) queryParams = { view }
    }
    try {
        const response = await axios(url, {
            method: requestMethod,
            headers: {
                "Authorization": `Bearer ${authToken}`
            },
            params: queryParams
        });
        const objectInfo = response?.data
        return objectInfo
    } catch (error: any) {
        if (error?.response?.status === 401) {
            await authorizeToCustomRest(authRequestOptions)
            return { error: 401 }
        }
    }
}